function SvgErp(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 31 18" {...props}>
      <path
        d="M0 5.364V18l8-1.362v-1.663L1.87 16.02v-4.025l5.604-.958V9.432l-5.604.956V6.724L8 5.678V4zm15.143 3.093c1.41-.246 2.52-1 2.52-2.552s-1.04-1.946-2.536-1.684l-2.907.508v4.24l2.923-.512zM10.46 3.648a.24.24 0 01.198-.234l4.626-.809c2.484-.433 4.158.564 4.158 2.99 0 2.043-1.006 3.218-2.637 3.925a.232.232 0 00-.115.333l2.557 4.27-1.773.312a.24.24 0 01-.248-.114l-2.438-4.093a.24.24 0 00-.248-.113l-2.122.37a.24.24 0 00-.198.235v4.633l-1.76.308V3.648zM26.497 6.63c1.304-.23 2.395-1.135 2.395-2.601 0-1.587-1.163-1.977-2.414-1.759l-2.992.524v4.362l3.01-.527zm-4.773-5.151L26.55.635c2.428-.425 4.156.652 4.156 3.076 0 2.408-1.62 4.069-4.139 4.51l-3.081.538v4.624l-1.762.307V1.479z"
      />
    </svg>
  );
}

export default SvgErp;
